import React from 'react';

import { cn } from '@pray/shared/utils/styles';

import type { CheckoutPaymentProps } from '../types';

import styles from './CheckoutPayment.module.scss';

export default function CheckoutPayment({ children, className }: CheckoutPaymentProps) {
  return <div className={cn(styles.payment, className)}>{children}</div>;
}
